import { CarIcon } from "lucide-react";
import Box from "../Box";

interface MaintenanceObjectiveProps {
  systemDisplayName: string | undefined;
  actionDisplayName: string | undefined;
  partDisplayName: string | undefined;
  actionDescription: string | undefined;
}

const MaintenanceObjective = ({
  systemDisplayName,
  actionDisplayName,
  partDisplayName,
  actionDescription,
}: MaintenanceObjectiveProps) => {
  return (
    <div className="flex flex-col md:flex-row items-start md:items-center flex-wrap gap-y-2 gap-x-4">
      {systemDisplayName && (
        <div className="flex">
          <Box className="bg-white-200 p-2 flex items-center gap-2">
            <CarIcon strokeWidth={1.5} />

            <p className="text-sm font-bold">
              {systemDisplayName}
            </p>
          </Box>
        </div>
      )}

      <div className="flex flex-col items-start">
        <p className="font-bold text-base">
          {actionDisplayName} {partDisplayName && (
            <>
              <span className="font-normal">em</span> {partDisplayName}
            </>
          )}
        </p>

        <p className="text-xs">
          {actionDescription}
        </p>
      </div>
    </div>
  );
}

export default MaintenanceObjective;
